module.exports = __webpack_public_path__ + "img/muleexLogo.c223df1d.svg";